import {
  Calendar,
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  DatePicker,
  EquipUITheme,
} from '@equip.health/ui';

import { formatObservationDate } from './utils';
import { GridItemProps } from '../../constants';

const { paragraph } = EquipUITheme.typography;

const DatetimeGridItem = ({
  colSpan,
  id,
  isEditing,
  onChange,
  value,
}: GridItemProps<Date>) => (
  <ChakraGridItem colSpan={colSpan}>
    {isEditing ? (
      <DatePicker
        id={`${id}__datetime`}
        maxDate={new Date()}
        onSelect={onChange}
        showTimeSelect
        timeIntervals={1}
        value={value}
      />
    ) : (
      <ChakraFlex align="center" overflow="wrap">
        <Calendar height="20px" width="20px" />
        <ChakraText {...paragraph} id={`${id}__datetime`} paddingLeft="16px">
          {formatObservationDate(value.toISOString())}
        </ChakraText>
      </ChakraFlex>
    )}
  </ChakraGridItem>
);

export default DatetimeGridItem;
